import WaitingScreen from 'components/WaitingScreen/WaitingScreen';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { selectBanDetails } from 'features/application/applicationSlice';
import { useAppSelector } from 'store/hooks';
import { useMemo } from 'react';
import type { BanDetails } from 'features/application/types';

type BanType = 'previously_banned' | 'temporary' | 'permanently';

const getBanType = (banDetails: BanDetails | undefined): BanType => {
  if (!banDetails) {
    return 'permanently';
  }

  if (banDetails.previouslyBanned) {
    return 'previously_banned';
  }

  if (banDetails.expirationTimestamp) {
    return 'temporary';
  }

  return 'permanently';
};

const UserBanned = () => {
  const { t } = useTranslation('waiting-screens');
  const banDetails = useAppSelector(selectBanDetails);

  const banType = getBanType(banDetails);

  const { text, title } = useMemo(() => {
    const baseKey = `user_banned.${banType}`;
    return {
      text: t(`${baseKey}.text`),
      title: t(`${baseKey}.title`),
    };
  }, [t, banType]);

  return (
    <WaitingScreen show title={title}>
      <Typography>{text}</Typography>
    </WaitingScreen>
  );
};

export default UserBanned;
